// src/components/WalletModal.tsx
import { useWallet } from "../context/WalletContext";

export default function WalletModal() {
  const { connect } = useWallet();

  const close = () => document.getElementById("wallet-modal")?.classList.add("hidden");

  const OPTS = [
    { type: "metamask" as const, icon: "🦊", name: "MetaMask", sub: "Browser extension wallet" },
    { type: "demo"     as const, icon: "🤖", name: "MeeBot Demo Wallet", sub: "ทดลองใช้งานโดยไม่ต้องติดตั้ง" },
  ];

  return (
    <div id="wallet-modal" className="hidden" onClick={(e) => e.target === e.currentTarget && close()} style={{
      position: "fixed", inset: 0, background: "rgba(0,0,0,.75)", zIndex: 200,
      display: "flex", alignItems: "center", justifyContent: "center",
      backdropFilter: "blur(6px)",
    }}>
      <div style={{
        background: "var(--bg2)", border: "1px solid rgba(124,58,237,.35)",
        borderRadius: 14, padding: 24, width: 400, maxWidth: "95vw",
        boxShadow: "0 24px 80px rgba(0,0,0,.6),0 0 30px rgba(124,58,237,.2)",
        animation: "modal-in .2s ease",
      }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 16 }}>
          <div>
            <div style={{ fontFamily: "var(--display)", fontSize: 20, fontWeight: 700, color: "#fff" }}>Connect Wallet</div>
            <div style={{ fontSize: 12, color: "var(--muted)", marginTop: 4 }}>เลือกกระเป๋าเงินสำหรับ MeeChain (Chain 13390)</div>
          </div>
          <button onClick={close} style={{ background: "none", border: "none", color: "var(--muted)", fontSize: 20, cursor: "pointer", lineHeight: 1 }}>✕</button>
        </div>

        <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
          {OPTS.map(opt => (
            <div key={opt.type} onClick={async () => { await connect(opt.type); close(); }} style={{
              display: "flex", alignItems: "center", gap: 12,
              padding: "12px 16px", background: "var(--bg3)",
              border: "1px solid rgba(124,58,237,.2)", borderRadius: 10,
              cursor: "pointer", transition: "all .18s",
            }}>
              <div style={{ fontSize: 24 }}>{opt.icon}</div>
              <div>
                <div style={{ fontSize: 14, fontWeight: 700, color: "#fff" }}>{opt.name}</div>
                <div style={{ fontSize: 11, color: "var(--muted)" }}>{opt.sub}</div>
              </div>
            </div>
          ))}

          <div style={{
            display: "flex", alignItems: "center", gap: 12,
            padding: "12px 16px", background: "var(--bg3)",
            border: "1px solid rgba(124,58,237,.12)", borderRadius: 10,
            opacity: .4, cursor: "not-allowed",
          }}>
            <div style={{ fontSize: 24 }}>🔗</div>
            <div>
              <div style={{ fontSize: 14, fontWeight: 700, color: "#fff" }}>WalletConnect</div>
              <div style={{ fontSize: 11, color: "var(--muted)" }}>Coming soon</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
